var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('terms-dialog', _vm._b({
    on: {
      "isLoaded": _vm.setTermsList,
      "input": function (value) {
        return _vm.$emit('input', value);
      },
      "isValid": function (isValid) {
        return _vm.$emit('isValid', isValid);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          isValid = _ref.isValid;
        return [_c('div', _vm._g({
          staticClass: "cursor-pointer mt-20px mt-md-40px"
        }, on), [_c('v-card', {
          attrs: {
            "outlined": "",
            "tile": ""
          }
        }, [_c('div', {
          staticClass: "pa-16px pa-md-20px"
        }, [_vm._l(_vm.termsList, function (terms) {
          return [_c('v-row', {
            key: terms._id,
            staticClass: "row--xs"
          }, [_c('v-col', {
            attrs: {
              "cols": "12",
              "sm": ""
            }
          }, [terms.code == 'privacy-agree' ? _c('v-checkbox', {
            attrs: {
              "value": _vm.selected.includes(terms._id),
              "hide-details": "",
              "color": "primary",
              "readonly": ""
            },
            scopedSlots: _vm._u([{
              key: "label",
              fn: function () {
                return [_vm._v(" " + _vm._s(terms.subject) + "에 동의합니다. "), _c('span', {
                  staticClass: "pl-4px",
                  class: [terms.necessary ? 'accent--text' : 'grey--text text--lighten-1']
                }, [_vm._v("(" + _vm._s(terms.necessary ? "필수" : "선택") + ")")])];
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1), _c('v-col', {
            staticClass: "mt-2px mt-sm-0",
            attrs: {
              "cols": "12",
              "sm": "auto"
            }
          }, [_c('u-btn-text-underline', {
            attrs: {
              "small": "",
              "color": "grey lighten-1"
            }
          }, [_vm._v("내용보기")])], 1)], 1)];
        })], 2)])], 1)];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, 'terms-dialog', {
    params: _vm.params
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }